var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheckCircleIcon = function SvgCheckCircleIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z",
    fill: "#5DBF4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.62 17.25a1 1 0 0 1-.7-.29l-4.13-4.13a1 1 0 1 1 1.42-1.41l3.41 3.42L18 7.48a1 1 0 0 1 1.41 0 1 1 0 0 1 0 1.41L11.33 17a1 1 0 0 1-.71.25Z",
    fill: "#fff"
  })));
};
export default SvgCheckCircleIcon;